
import { defineComponent, ref, onMounted, computed, watch } from "vue";
import { store } from "@/store";

import { canvas } from "@/canvas-api/Canvas";
import { handleGridLines } from "@/canvas-api/GridLines";
import { handleGuidelines } from "@/canvas-api/GuideLines";

import ToolTitle from "@/components/SideToolBar/Tools/ToolTitle.vue";

import { ActionTypes } from "@/store/actions";
import { SettingsState } from "@/types";

export default defineComponent({
  name: "Settings",
  components: {
    ToolTitle,
  },
  setup() {
    const title = ref("");

    const settingsState = computed(() => store.state.settingsState);

    const guidelinesSlide = ref<HTMLDivElement>();
    const guidelinesInput = ref<HTMLInputElement>();

    const rulersSlide = ref<HTMLDivElement>();
    const rulersInput = ref<HTMLInputElement>();

    const gridSlide = ref<HTMLDivElement>();
    const gridInput = ref<HTMLInputElement>();

    const elements = {
      guidelines: {
        slider: guidelinesSlide,
        input: guidelinesInput,
      },
      rulers: {
        slider: rulersSlide,
        input: rulersInput,
      },
      grid: {
        slider: gridSlide,
        input: gridInput,
      },
    } as { [key: string]: any };

    onMounted(() => {
      for (let setting of Object.keys(settingsState.value)) {
        if (settingsState.value[setting as keyof SettingsState]) {
          if (elements[setting].slider.value && elements[setting].input.value) {
            const slide = elements[setting].slider.value;

            slide.style.left = "50%";
            slide.style.borderTopLeftRadius = "0px";
            slide.style.borderBottomLeftRadius = "0px";
            slide.style.borderTopRightRadius = "4px";
            slide.style.borderBottomRightRadius = "4px";

            elements[setting].input.value.checked = true;
          } else {
            throw new Error("Missing Element in handle click!, Settings.vue");
          }
        }
      }

      title.value = "Settings";
    });

    const handleClick = (e: { target: HTMLInputElement }, setting: string) => {
      if (elements[setting].slider.value && elements[setting].input.value) {
        if (elements[setting].input.value.checked) {
          const slide = elements[setting].slider.value;
          slide.style.left = "0";
          slide.style.borderTopLeftRadius = "4px";
          slide.style.borderBottomLeftRadius = "4px";
          slide.style.borderTopRightRadius = "0px";
          slide.style.borderBottomRightRadius = "0px";
        } else {
          const slide = elements[setting].slider.value;
          slide.style.left = "50%";
          slide.style.borderTopLeftRadius = "0px";
          slide.style.borderBottomLeftRadius = "0px";
          slide.style.borderTopRightRadius = "4px";
          slide.style.borderBottomRightRadius = "4px";
        }

        elements[setting].input.value.checked = !elements[setting].input.value.checked;
      } else {
        throw new Error("Missing Element in handle click!, Settings.vue");
      }

      const payload: string = setting;
      store.dispatch(ActionTypes.SET_SETTINGS_STATE, payload);
    };

    const guidelines = computed<boolean>(() => store.getters.settingsState.guidelines);
    const showGrid = computed<boolean>(() => store.getters.settingsState.grid);

    watch(guidelines, (newState: boolean) => {
      handleGuidelines(canvas.value, newState);
    });

    watch(showGrid, () => {
      handleGridLines(canvas.value);
    });

    return {
      title,
      guidelinesSlide,
      guidelinesInput,
      rulersSlide,
      rulersInput,
      gridSlide,
      gridInput,
      handleClick,
    };
  },
});
